<h3 mat-dialog-title>Usuário da conta</h3>
<mat-dialog-content>

    <span class="helper">
        Um convite será gerado para a pessoa se tornar usuário da conta empresarial
    </span>

    <form [formGroup]="formUser">
        <div class="row">
            <mat-form-field appearance="outline">
                <mat-label>Primeiro nome</mat-label>
                <input type="text" matInput placeholder="Primeiro nome do usuário" formControlName="firstname"/>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Sobrenome</mat-label>
                <input type="text" matInput placeholder="Sobrenome do usuário" formControlName="lastname"/>
            </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field appearance="outline">
                <mat-label>Email do usuário</mat-label>
                <input type="email" matInput placeholder="Email do usuário" formControlName="email"/>
            </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field appearance="outline">
                <mat-label>Senha</mat-label>
                <input minlength="6" type="text" matInput placeholder="Senha do usuário" formControlName="password"/>
            </mat-form-field>
        </div>

        <div class="row">
            <mat-slide-toggle color="primary" formControlName="isAdmin">é administrador</mat-slide-toggle>
        </div>
        
        <div class="row">
            <span class="helper">
                Usuário administrador poderá adicionar, editar e excluir outros usuários de acesso do sistema<br>
                Além de poder acessar e gerenciar todos os processos seletivos da empresa.
            </span>    
        </div>        

    </form>

</mat-dialog-content>
<mat-progress-bar color="primary" mode="indeterminate" *ngIf="submiting"></mat-progress-bar>
<mat-dialog-actions *ngIf="!submiting">
    <button mat-button mat-dialog-close color="accent">Fechar</button>
    <button mat-raised-button color="primary" (click)="submitUser()">Salvar</button>
</mat-dialog-actions>